/**
 * Formats a date string as a human-readable date and time.
 *
 * @example formatDateTime('2024-03-15T14:30:00') // "Mar 15, 2024, 2:30 PM"
 */
export default function formatDateTime(dateString: string): string {
  const date = new Date(dateString);
  const options: Intl.DateTimeFormatOptions = {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  };
  return date.toLocaleString('en-US', options);
}
